import { Image, AspectRatio, CSSObject } from '@chakra-ui/react'

import ImageSrc from '@/svg/services/decor-2.svg'

interface Props {
  sx?: CSSObject
}

function Decor2({ sx }: Props): React.ReactElement {
  return (
    <AspectRatio
      ratio={189 / 297}
      sx={{
        zIndex: -1,
        top: 0,
        right: 0,
        transform: 'translate3d(10%, -30%, 0)',
        maxW: '189px',
        w: '20%',
        position: 'absolute',
        overflow: 'visible',
        ...sx,
      }}
    >
      <Image
        src={ImageSrc}
        alt="Decoration 2"
        sx={{ objectFit: 'contain !important' }}
      />
    </AspectRatio>
  )
}
export default Decor2
